"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getColorBoxShadow = void 0;
var _constants = require("../constants");
const getColorBoxShadow = (param)=>{
    let { background, theme } = param;
    return _constants.WHITE_COLORS.includes(background) ? theme.palette.blueGrey[100] : theme.palette.common.white;
};
exports.getColorBoxShadow = getColorBoxShadow;
